// OPEN IN 3D VIEWER (docs SIGNOFF-SPEC S1, selected tile): the real model, through the
// viewer Construction tracking uses, isolated to the elements of one tile and framed on
// them.
import React, { useEffect, useState } from "react";
import { Alert, Modal, Spin } from "antd";
import { Link } from "react-router-dom";
import { getTileElements } from "api/signoff";
import ModelStage from "pages/Tracking/ModelStage";

export default function TileModelModal({ projectId, tile, onClose }) {
  const [els, setEls] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    getTileElements(projectId, tile.key).then(setEls).catch((e) => setErr(e.message));
  }, [projectId, tile.key]);
  return (
    <Modal open width="calc(90 * var(--vw))" style={{ top: 24 }} title={`Tile ${tile.key} in the model${els ? ` · ${els.total.toLocaleString()} elements` : ""}`}
           onCancel={onClose} footer={<Link to={`/tracking/${projectId}`}>Open Construction tracking</Link>} destroyOnClose>
      {err ? <Alert type="error" showIcon message={err} /> : null}
      {!els && !err ? <Spin className="m-4" /> : null}
      {els && !els.uids.length ? <Alert type="info" showIcon message="No model elements in this tile." /> : null}
      {els && els.uids.length ? (
        <div style={{ height: "calc(78 * var(--vh))" }}>
          <ModelStage projectId={projectId} isolateUids={els.uids} focusUids={els.uids} focusKey={1} highlightUids={els.uids} autoFrame />
        </div>
      ) : null}
    </Modal>
  );
}
